import {
  ProductFeedbackFeature,
  useSubmitFeedback,
} from "@/hooks/use-submit-feedback";
import { useCallback } from "react";

/** Tells this app apart from the other ones showing the same dialog. */
const FEEDBACK_APP = "Sphere XG Viewer";

/** The feedback given by a user being redirected back to the HoloBuilder WebEditor. */
export type ExperienceFeedbackParams = {
  /** The reasons selected by the user, empty when none was selected. */
  reasons: string[];

  /** The free text the user wrote to explain the switch back. */
  feedback: string;
};

/** The experience feedback as sent to the webhook, including the fields filled by the hook. */
type ExperienceFeedbackContent = ExperienceFeedbackParams & {
  /** The title the feedback is shown under. */
  feature: ProductFeedbackFeature;

  /** The app the user is being redirected away from. */
  app: string;
};

/**
 * @returns a callback function to submit the feedback of a user being redirected back to the
 *  HoloBuilder WebEditor, showing a toast when the operation fails.
 */
export function useSubmitExperienceFeedback(): (
  feedbackContent: ExperienceFeedbackParams,
) => Promise<boolean> {
  const submitFeedback = useSubmitFeedback<ExperienceFeedbackContent>();

  return useCallback(
    (feedbackContent: ExperienceFeedbackParams) =>
      submitFeedback({
        feature: ProductFeedbackFeature.xgRedirectToHb,
        app: FEEDBACK_APP,
        ...feedbackContent,
      }),
    [submitFeedback],
  );
}
